import { useState } from "react";

type FormResponse = {
  code?: string;
  message?: string;
  meta?: { message?: string; detail?: string };
};

const SUBMIT_ADDR = "https://readdy.ai/api/form/dahbodboh653ivfvnqng";

const INTERESTS = ["文娱观察", "网络热点", "产业逻辑", "舆情复盘", "平台生态"];

export default function SubscribeForm() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const honeypot = String(formData.get("website_alt") ?? "").trim();
    formData.delete("website_alt");
    if (honeypot) {
      setStatus("success");
      setMessage("订阅成功，简报会在每个工作日发送到你的邮箱。");
      form.reset();
      return;
    }

    setStatus("loading");
    setMessage("");

    try {
      const params = new URLSearchParams();
      formData.forEach((value, key) => {
        const text = String(value).trim();
        if (text === "") return;
        params.append(key, text);
      });

      const response = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params.toString(),
      });

      const responseText = await response.text();
      let parsed: FormResponse | null = null;
      try {
        parsed = JSON.parse(responseText) as FormResponse;
      } catch {
        parsed = null;
      }

      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
      const isSpam = typeof serverMsg === "string" && serverMsg.toLowerCase().includes("spam");

      if (response.ok && parsed?.code === "OK" && !isSpam) {
        setStatus("success");
        setMessage("订阅成功！每日瓜料简报会在工作日发送到你的邮箱。");
        form.reset();
      } else {
        setStatus("error");
        setMessage(serverMsg || "提交失败，请稍后重试。");
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，提交失败，请稍后重试。");
    }
  };

  return (
    <form
      data-readdy-form
      id="subscribe-form"
      onSubmit={handleSubmit}
      className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-7"
    >
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-[1fr_auto] sm:items-end">
        <div className="flex flex-col gap-1.5">
          <label htmlFor="subscribe-email" className="text-xs font-medium tracking-wide text-foreground-600">
            邮箱地址
          </label>
          <input
            id="subscribe-email"
            type="email"
            name="email"
            required
            placeholder="you@example.com"
            className="w-full rounded-md border border-background-300 bg-background-50 px-3.5 py-2.5 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400"
          />
        </div>
        <button
          type="submit"
          disabled={status === "loading"}
          className="h-[42px] whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {status === "loading" ? "提交中…" : "免费订阅"}
        </button>
      </div>

      <div className="mt-4 flex flex-wrap items-center gap-2">
        <span className="text-xs text-foreground-500">关注方向：</span>
        {INTERESTS.map((item) => (
          <label
            key={item}
            className="inline-flex cursor-pointer items-center gap-1.5 rounded-full border border-background-300 px-3 py-1 text-xs text-foreground-700 transition-colors has-[:checked]:border-primary-300 has-[:checked]:bg-primary-100 has-[:checked]:text-primary-700"
          >
            <input type="checkbox" name="interest" value={item} className="h-3 w-3 accent-[oklch(var(--primary-500))]" />
            {item}
          </label>
        ))}
      </div>

      <input
        type="text"
        name="website_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="field-extra-spacer"
      />

      {status !== "idle" && status !== "loading" && (
        <div
          role="status"
          className={`mt-4 flex items-start gap-2 rounded-md border px-3.5 py-2.5 text-sm ${
            status === "success"
              ? "border-secondary-300 bg-secondary-50 text-secondary-800"
              : "border-primary-300 bg-primary-50 text-primary-700"
          }`}
        >
          <i className={`mt-0.5 ${status === "success" ? "ri-checkbox-circle-line" : "ri-error-warning-line"}`} aria-hidden="true"></i>
          <span>{message}</span>
        </div>
      )}
      <p className="mt-3 text-xs leading-relaxed text-foreground-400">
        我们只发送内容更新，不做营销推广，随时可以退订。
      </p>
    </form>
  );
}